import {Color} from "@k/js/colorObject";

export class ColorViewDataWithOutlineAndPatterns {

    public outlineColorvalue: null | number;
    public colorValue: number;
    public colorCode: string;
    public colorCodeNr: number;
    public palette: string;
    public hatPattern: boolean;


    public constructor(color: Color, outlineColorValue: number | null) {
        this.colorCode = color.colorCode;
        this.colorCodeNr = color.colorCodeNr;
        this.colorValue = color.colorValue;
        this.outlineColorvalue = outlineColorValue;
        this.palette = color.palette;
        this.hatPattern = color.hatPattern;
    }
}